import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service'

@Component({
  selector: 'callback',
  templateUrl: './callback.component.html'
})
export class CallbackComponent implements OnInit {
  isNewArrival: string;

  constructor(public auth: AuthService) {

  }//end cosnt

  ngOnInit() {
    this.isNewArrival = localStorage.getItem('isNew');
    if (this.isNewArrival == undefined || this.isNewArrival == null) {
      localStorage.clear();
      sessionStorage.removeItem('accountid');
      sessionStorage.removeItem('graphData');
      localStorage.setItem('isNew', "1");
      this.auth.login();
    } else if (Number(this.isNewArrival) >= 1) {
      this.auth.handleAuthentication();
    }
  }//end ngOnInit
}//end class



